import { render } from "./AddMainEngineEmissionsComponent.vue?vue&type=template&id=feffc464&scoped=true"
import script from "./AddMainEngineEmissionsComponent.vue?vue&type=script&lang=js"
export * from "./AddMainEngineEmissionsComponent.vue?vue&type=script&lang=js"

import "./AddMainEngineEmissionsComponent.vue?vue&type=style&index=0&id=feffc464&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feffc464"]])

export default __exports__